export default class FormInputClassesController {
  constructor (element) {
    this._element = element
    this._bindUIActions()
  }

  _bindUIActions () {
    console.log('sdfda')
    const inputElements = this._element.querySelectorAll('.form-input-state')
    const updateClass = (el) => {
      console.log('updateclass', el)
      console.log('value', el.value)
      if (el.value === '') {
        el.classList.add('form-input-state--empty')
        el.classList.remove('form-input-state--not-empty')
      } else {
        el.classList.add('form-input-state--not-empty')
        el.classList.remove('form-input-state--empty')
      }
    }
    ;[].forEach.call(inputElements, element => {
      console.log('fsdf', element)
      console.log('fsdf', element.nodeName)
      console.log('fsdf', element.type)
      if (element.nodeName === 'INPUT') {
        if (element.type !== 'radio' && element.type !== 'checkbox') {
          const handler = () => {
            updateClass(element)
          }
          element.addEventListener('input', handler)
          element.addEventListener('change', handler)
          handler()
        }
      }
      if (element.nodeName === 'SELECT') {
        const handler = () => {
          updateClass(element)
        }
        element.addEventListener('change', handler)
        handler()
      }
    })
  }
}
